export default function EmptyModule(): JSX.Element {
	return <></>;
}
